export default __webpack_public_path__ + "static/media/trip_report_bg.dccf4c6f.png";